export const OPTIONS = [
  { label: "Button 0",      value: "button0"     },
  { label: "Button 1",      value: "button1"     },
  { label: "Move Up",       value: "moveup"      },
  { label: "Move Down",     value: "movedown"    },
  { label: "Move Left",     value: "moveleft"    },
  { label: "Move Right",    value: "moveright"   },
  { label: "Open Apple",    value: "openapple"   },
  { label: "Closed Apple",  value: "closedapple" },
  { label: "Return",        value: "return"      },
  { label: "Space Bar",     value: "space"       },
  { label: "Escape",        value: "escape"      },
  { label: "Tab",           value: "tab"         },
  { label: "Delete",        value: "delete"      },
  { label: "A", value: "a" }, { label: "B", value: "b" }, { label: "C", value: "c" },
  { label: "D", value: "d" }, { label: "E", value: "e" }, { label: "F", value: "f" },
  { label: "G", value: "g" }, { label: "H", value: "h" }, { label: "I", value: "i" },
  { label: "J", value: "j" }, { label: "K", value: "k" }, { label: "L", value: "l" },
  { label: "M", value: "m" }, { label: "N", value: "n" }, { label: "O", value: "o" },
  { label: "P", value: "p" }, { label: "Q", value: "q" }, { label: "R", value: "r" },
  { label: "S", value: "s" }, { label: "T", value: "t" }, { label: "U", value: "u" },
  { label: "V", value: "v" }, { label: "W", value: "w" }, { label: "X", value: "x" },
  { label: "Y", value: "y" }, { label: "Z", value: "z" },
  { label: "1", value: "1" }, { label: "2", value: "2" }, { label: "3", value: "3" },
  { label: "4", value: "4" }, { label: "5", value: "5" }, { label: "6", value: "6" },
  { label: "7", value: "7" }, { label: "8", value: "8" }, { label: "9", value: "9" },
  { label: "0", value: "0" },
  { label: "-",  value: "minus"     },
  { label: "=",  value: "equal"     },
  { label: "[",  value: "lbracket"  },
  { label: "]",  value: "rbracket"  },
  { label: "\\", value: "backslash" },
  { label: ";",  value: "semicolon" },
  { label: "'",  value: "quote"     },
  { label: "`",  value: "backtick"  },
  { label: ",",  value: "comma"     },
  { label: ".",  value: "period"    },
  { label: "/",  value: "slash"     },
];
